module.exports = __webpack_public_path__ + "img/Rottaria.eb6a515a.png";